import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const getTransactionStatus = (type) => apiActionCreator({
  'endpoint': `/transactions/${type}/status`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_TRANSACTION_STATUS_REQUEST,
    ActionTypes.GET_TRANSACTION_STATUS_SUCCESS,
    [
      ActionTypes.GET_TRANSACTION_STATUS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const loadJapanPartMaster = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/parts/catalog',
      'authenticated': true,
      'types': [
        ActionTypes.LOAD_JAPAN_PART_MASTER_REQUEST,
        () => {
          dispatch(getTransactionStatus('JAPAN_PARTS_LIST'));
          return {'type': ActionTypes.LOAD_JAPAN_PART_MASTER_SUCCESS};
        },
        [
          ActionTypes.LOAD_JAPAN_PART_MASTER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'data': data,
    })
  );
};

export const loadAlternativePartMaster = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/parts/extra-catalogs',
      'authenticated': true,
      'types': [
        ActionTypes.LOAD_EXTRA_PARTS_LIST_REQUEST,
        () => {
          dispatch(getTransactionStatus('OTHERS_PARTS_LIST'));
          return {'type': ActionTypes.LOAD_EXTRA_PARTS_LIST_SUCCESS};
        },
        [
          ActionTypes.LOAD_EXTRA_PARTS_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'data': data,
    })
  );
};

export const getBackupRecords = () => apiActionCreator({
  'endpoint': '/parts/catalog-backup',
  'authenticated': true,
  'types': [
    ActionTypes.GET_BACKUP_RECORDS_REQUEST,
    ActionTypes.GET_BACKUP_RECORDS_SUCCESS,
    [
      ActionTypes.GET_BACKUP_RECORDS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getSavedRecords = (alias) => apiActionCreator({
  'endpoint': `/parts/transactions/${alias}/progress`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_SAVED_RECORDS_REQUEST,
    ActionTypes.GET_SAVED_RECORDS_SUCCESS,
    [
      ActionTypes.GET_SAVED_RECORDS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearLoadingStatus = () => ({
  'type': ActionTypes.CLEAR_LOADING_STATUS,
});

export const selectPartsListOrigin = (origin) => ({
  'type': ActionTypes.SELECT_PARTS_LIST_ORIGIN,
  'payload': origin,
});

export const changePartsPrice = () => apiActionCreator({
  'endpoint': '/parts/price-calculation',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PARTS_PRICE_CHANGE,
    [
      {'type': ActionTypes.SAVE_PARTS_PRICE_SUCCESS},
      (response) => buildSuccessMessage(response, 'Cálculo de Precios ejecutado correctamente'),
    ],
    [
      ActionTypes.SAVE_PARTS_PRICE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
});
export const getChangePricesStatus = () => apiActionCreator({
  'endpoint': '/parts/price-calculation',
  'authenticated': true,
  'types': [
    ActionTypes.GET_PRICE_CHANGE_STATUS_REQUEST,
    ActionTypes.GET_PRICE_CHANGE_STATUS_SUCCESS,
    [
      ActionTypes.GET_PRICE_CHANGE_STATUS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
